import { AlertService } from './../../services/alert.service';
import { AuthBaseService } from './../../services/auth/auth-base.service';

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { AlertModalComponent } from '../modals/alertModal/alertModal.component';



@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    runRefreshToken: boolean = true;

    constructor(
        public authBaseService: AuthBaseService,
        public alertService: AlertService,
        private dialog: MatDialog,
    ) {

    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<any> {

        return next.handle(request)
            .pipe(
                tap(data => {
                    if (data instanceof HttpResponse) {

                        if (data?.body?.error) {
                            this.alertService.error(data.body.error);
                            throw new Error(data.body.error);
                        }
                    }
                }),
                catchError(err => {

                    switch (err.status) {
                        case 0:
                            this.alertService.error(err.statusText);
                            // console.error(err.error);
                            break;

                        case 400:
                            if (err.error && err.error.error_description && err.error.error_description == 'Code not valid') {
                                this.alertService.error('Código retornado do AMEI inválido');
                            } else if (err.error?.message) {
                                this.alertService.error(err.error.message);
                            } else if (typeof err.error === 'string' && err.error) {
                                this.alertService.error(err.error);
                            } else {
                                this.alertService.error('Requisição inválida. Verifique os dados enviados.');
                            }
                            break;

                        case 401:
                            if (err.error !== null) {
                                this.alertService.error('Não autorizado');
                            } else {
                                this.alertService.error('Sessão expirada');
                            }
                            this.authBaseService.logout();
                            break;
                        case 403:
                            this.alertService.error('Usuário não possui acesso ao sistema');
                            break;
                        case 415:

                            break;
                        case 500:
                            const error = err.error.message || err.statusText;
                            const skipErrorModal = request.headers?.get('X-Skip-Error-Modal') === 'not-registered';

                            if (error.includes('Access Token nulo')) {
                                this.alertService.error('Não autorizado');
                                this.authBaseService.logout();
                            } else {
                                const isWrongPassword = error === 'Usuário e/ou senha de rede incorreto! Digite novamente ou entre em contato com o administrador de rede.';
                                const isOwnManager = error === 'Não é possível fazer solicitação para o seu próprio gestor';
                                const isNotRegistered = error.includes('não está cadastrado no PROTHEUS');


                                if (isWrongPassword || isOwnManager) {
                                this.dialog.open(AlertModalComponent, {
                                    data: { type: 'error', msg: error },
                                    panelClass: ['alert-modal', 'error'],
                                    width: '480px'
                                });
                                } else if (isNotRegistered && !skipErrorModal) {
                                this.dialog.open(AlertModalComponent, {
                                    data: { type: 'error', msg: error },
                                    panelClass: ['alert-modal', 'error'],
                                    width: '480px'
                                });
                                } else if (!isNotRegistered) {
                                this.alertService.error(error);
                                }
                                // isNotRegistered && skipErrorModal = não faz nada, RID Fornecedor trata no componente
                            }
                        break;

                        case 503:
                        case 504:
                            this.alertService.error('Ocorreu um erro com o servidor.');
                            break;
                    }

                    return throwError(err);
                }));
    }
}

